<template>
  <div class="flow-block">
    <h4 class="flow-title">Confira antes de enviar</h4>
    <p class="flow-subtitle">
      Revise os dados abaixo. Ao confirmar, criamos uma categoria por dash com os contatos da planilha.
    </p>

    <div class="review-summary">
      <div class="review-pill">
        <span class="review-pill-label">Planilhas</span>
        <span class="review-pill-value">{{ uploads.length }}</span>
      </div>
      <div class="review-pill">
        <span class="review-pill-label">Categorias a criar</span>
        <span class="review-pill-value">{{ totalReviewItems }}</span>
      </div>
      <div class="review-pill">
        <span class="review-pill-label">Dashes envolvidas</span>
        <span class="review-pill-value">{{ uniqueTenantsInReview }}</span>
      </div>
    </div>

    <div class="review-cards mt-3">
      <div
        v-for="(group, groupIdx) in reviewGroupedByFile"
        :key="`group-${groupIdx}`"
        class="review-group-card"
      >
        <div class="review-group-header">
          <div class="d-flex" style="gap: 10px; align-items: center;">
            <span class="color-swatch" :style="{ background: group.colorTag }"></span>
            <strong>{{ group.groupName }}</strong>
          </div>
          <span class="review-group-meta">
            {{ group.fileName }}<span v-if="group.sheetName"> · {{ group.sheetName }}</span><span v-if="group.totalRows !== null"> · {{ group.totalRows }} {{ group.totalRows === 1 ? 'contato' : 'contatos' }}</span>
          </span>
        </div>
        <div class="review-group-body">
          <span class="text-small mr-2">Aplica em:</span>
          <span
            v-for="tenant in group.tenants"
            :key="`${groupIdx}-${tenant.id}`"
            class="tenant-pill"
          >{{ tenant.label }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap mt-4" style="gap: 10px;">
      <vs-button
        color="primary"
        :disabled="loading"
        @click="$emit('confirm-execute')"
      >
        {{ loading ? 'Enviando...' : 'Confirmar e enviar' }}
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MassCustomerCategoriesStepReview',
  props: {
    uploads: {
      type: Array,
      required: true,
    },
    reviewGroupedByFile: {
      type: Array,
      required: true,
    },
    totalReviewItems: {
      type: Number,
      required: true,
    },
    uniqueTenantsInReview: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
